class ProductAccordian extends HTMLElement {
  constructor() {
    super();
    this.closed = true;
    this.toggles = this.querySelectorAll('.toggle');
    this.ons = this.querySelectorAll('.on');
    this.offs = this.querySelectorAll('.off');
    this.sects = this.querySelectorAll('.sect');
    this.addEventListeners();
  }

  addEventListeners() {
        for (var i = 0; i < this.toggles.length; i++) {
            this.toggles[i].addEventListener( 'mousedown', this.toggle.bind(this) );
            this.toggles[i].addEventListener( 'keyup', this.keyUp.bind(this));
        }
  }

  keyUp(event) {
     if (event.keyCode == 13) {
        this.toggle(event)
			}
    return false;
  }

  toggle(event) {
    this.closed = !this.closed;
    if (this.closed) {
      event.currentTarget.setAttribute('aria-expanded', 'false')
    } else {
      event.currentTarget.setAttribute('aria-expanded', 'true');
    }
    for (var i = 0; i < this.sects.length; i++) {
        if (this.closed) this.sects[i].classList.add('closed');
        else this.sects[i].classList.remove('closed')
    }
    for (var i = 0; i < this.ons.length; i++) {
        if (this.closed) this.ons[i].classList.add('closed');
        else this.ons[i].classList.remove('closed')
    }
    for (var i = 0; i < this.offs.length; i++) {
        if (this.closed) this.offs[i].classList.remove('closed');
        else this.offs[i].classList.add('closed')
    }
  }
}

customElements.define('product-accordian', ProductAccordian);
